export enum AbsoluteRoutes {
  invite = '/invite/:id',
  expertsList = '/experts',
  expert = '/expert/:id',
  booking = '/booking',
  signup = '/signup',
  verificationCode = '/verify',
  login = '/login',
  services = '/facility',
  appointment = '/appointment',
}
